document.querySelectorAll('.info-accordion__header').forEach(function(summary) {
  summary.addEventListener('click', function(e) {
    e.preventDefault();
    var item = summary.closest('.info-accordion__item');
    var body = item.querySelector('.info-accordion__body');
    if (item.open) {
      body.style.height = body.scrollHeight + 'px';
      body.offsetHeight;
      body.style.height = '0';
      body.addEventListener('transitionend', function done() {
        item.open = false;
        body.style.height = '';
        body.removeEventListener('transitionend', done);
      });
    } else {
      item.open = true;
      body.offsetHeight;
      body.style.height = body.scrollHeight + 'px';
      body.addEventListener('transitionend', function done() {
        body.style.height = 'auto';
        body.removeEventListener('transitionend', done);
      });
    }
  });
});
